import React, { forwardRef } from "react";
import classNames from "classnames";

import "./styles.styl";

const Field = forwardRef((props, ref) => {
  const {
    className,
    label,
    placeholder,
    name,
    type,
    info,
    required,
    errors,
    InputComponent,
    ...rest
  } = props;
  return (
    <div
      id={"field-" + name}
      className={classNames(
        "field",
        {
          "has-errors": errors,
        },
        "is-" + type,
        className,
      )}
    >
      <InputComponent
        className="field__input"
        type={type}
        errors={errors}
        id={name}
        name={name}
        required={required}
        placeholder={placeholder}
        label={label}
        inputref={ref}
        {...rest}
      />
      {errors && (
        <div
          className="field__error"
          dangerouslySetInnerHTML={{ __html: errors.join(", ") }}
        />
      )}
      {info && <div className="field__info">{info}</div>}
    </div>
  );
});

export default Field;
